/**
 * The minimum font size for subtitles.
 */
export const MIN_SUBTITLES_FONT_SIZE = 16;
